import makeStyles from '@mui/styles/makeStyles';

const listTemplateStyles = makeStyles((theme) => ({
    listItemAvatar: {
        color: theme.palette.primary.main,
    },
    h2: {
        textAlign: 'center',
        color: '#ED7571',
    },
    paper: {
        borderRadius: 15,
        padding: 20,
        height: '100%',
    },
    listElement: { marginTop: -25 },
    title: {
        fontSize: '1rem',
    },
    inputLabel: {
        color: theme.palette.text.secondary,
        fontSize: '0.875rem',
        marginBottom: '0.5rem',
    },
    circularProgressDiv: {
        display: 'flex',
        justifyContent: 'center',
    },
    dialogActions: {
        marginTop: '1.5rem',
        alignItems: 'center',
    },
    verifiedPartnersDescription: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '14px',
        lineHeight: '21px',
        color: theme.palette.text.secondary,
    },
    listingDetailsTitle: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '14px',
        lineHeight: '21px',
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.text.primary,
        textAlign: 'left',
        marginBottom: '1rem',
    },
    listingDetailsValue: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '18px',
        lineHeight: '21px',
        textAlign: 'right',
        color: theme.palette.primary.main,
        marginBottom: '1rem',
        overflowWrap: 'break-word',
    },
    checkbox: {
        background: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        boxSizing: 'border-box',
        borderRadius: '3px',
    },
    disclosureRequirementsPrimaryList: {
        fontFamily: 'Saira',
        fontStyle: 'normal',
        fontWeight: 550,
        fontSize: '12px',
        lineHeight: '22px',
        color: theme.palette.text.primary,
    },
    disclosureRequirementsSecondaryList: {
        fontFamily: 'Saira',
        fontStyle: 'normal',
        fontWeight: 550,
        fontSize: '12px',
        lineHeight: '22px',
        color: theme.palette.text.secondary,
        marginLeft: '1rem',
    },
    quartersList: {
        fontFamily: 'Saira',
        fontStyle: 'normal',
        fontWeight: 550,
        fontSize: '12px',
        lineHeight: '22px',
        color: theme.palette.text.primary,
        marginLeft: '3rem',
    },
    open: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '12px',
        lineHeight: '21px',
        textAlign: 'right',
        //textTransform: 'uppercase',
        color: '#ED7571',
        verticalAlign: '-webkit-baseline-middle',
    },
    completed: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '12px',
        lineHeight: '21px',
        //textTransform: 'uppercase',
        color: '#4E984B',
        textAlign: 'right',
        verticalAlign: '-webkit-baseline-middle',
    },
    editItem: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '12px',
        lineHeight: '22px',
        textAlign: 'right',
        color: theme.palette.primary.main,
        width: '100%',
        display: 'inherit',
        alignItems: 'inherit',
        justifyContent: 'initial',
    },
    dialogSecondaryList: {
        fontFamily: 'Saira',
        fontStyle: 'normal',
        fontWeight: 550,
        fontSize: '12px',
        lineHeight: '22px',
        color: theme.palette.text.secondary,
    },
}));

export default listTemplateStyles;
